import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  clearHistoryFilters
} from "../../actions/historyActions";

export function ClearFilters({ activeFilters, clearFilters }) {
  if (!activeFilters) {
    return null;
  }

  return (
    <a className="clearFilters" onClick={clearFilters}>
      <img src={require("./assets/clear.png")} alt="Clear Filters" />
      <em>Clear Filters ({`${activeFilters}`})</em>
    </a>
  );
}

ClearFilters.displayName = "History.ClearFilters";

ClearFilters.propTypes = {
  activeFilters: PropTypes.number.isRequired,
  clearFilters: PropTypes.func.isRequired,
};

ClearFilters.defaultProps = {
  activeFilters: 0,
};

function mapStateToProps(state, ownProps) {
  return {
    activeFilters: state.historyFilters.activeFilters,
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    clearFilters: () => {
      dispatch(clearHistoryFilters());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ClearFilters);



// WEBPACK FOOTER //
// ./app/components/History/ClearFilters.jsx